<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-dropdown @command="handleNewReportCommand"
                     v-has="'Create Report'">
          <el-button type="primary"
                     size="medium">
            {{$t('task.NewReport')}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{Type:0, Name:$t('task.Task')}">{{$t('task.Task')}}</el-dropdown-item>
            <el-dropdown-item :command="{Type:1, Name:$t('task.ProductInstallation')}">{{$t('task.ProductInstallation')}}</el-dropdown-item>
            <el-dropdown-item :command="{Type:2, Name:$t('task.Moisture')}">{{$t('task.Moisture')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template slot="tab">
        <el-tabs @tab-click="changeReportType"
                 v-model="tab">
          <el-tab-pane :label="$t('report.All')"
                       name="All"></el-tab-pane>
          <el-tab-pane v-for=" i of reportType"
                       :key="i.Value"
                       :label="$t('report.'+i.Value)"
                       :name="i.Value"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="search">
        <el-input v-model="condition.Name"
                  :placeholder="$t('report.SearchReportName')"
                  size="mini"
                  style="margin-left:16px"
                  clearable
                  @change="getTaskReportList()"></el-input>
        <SortControl @sortList="sortList"
                     :orderBy="sortValue">
          <template slot="sort">
            <el-select size="mini"
                       @change="sort"
                       placeholder="Orderby"
                       v-model="sortBy">
              <el-option v-for="item in sortType"
                         :key="item.name"
                         :label="item.name"
                         :value="item.value"></el-option>
            </el-select>
          </template>
        </SortControl>
      </template>
    </sub-header>
    <div class="main"
         :class="filter.showFilter?'main-showfilter':''">
      <div class="table-box">
        <myScroll style="width:100%;height:100%">
          <el-table ref="reportTable"
                    :data="list"
                    size="small"
                    v-loading="loading"
                    :highlight-current-row="false"
                    @row-click="selectRow"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange"
                    style="position:absolute"
                    :default-sort="{prop: sortField, order: sortOrder}"
                    @sort-change="sortChange">
            <!-- <el-table-column type="selection"
                             width="55">
            </el-table-column> -->
            <el-table-column width="55">
              <template slot-scope="scope">
                <div class="row-link"
                     @click="previewReport(scope.row.UId, scope.row.Name)">
                  <svg-icon :iconClass="scope.row.icon"></svg-icon>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.Name')"
                             prop="Name">
              <template slot-scope="scope">
                <div class="row-link"
                     @click="previewReport(scope.row.UId, scope.row.Name)">
                  <span class="row-name">
                    {{scope.row.Name}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.ProjectName')"
                             prop="JobsiteName"
                             v-if="!jobsiteID"
                             sortable>
              <template slot-scope="scope">
                {{scope.row.JobsiteName}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.Plan')"
                             prop="PlanName">
              <template slot-scope="scope">
                {{scope.row.PlanName}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.CreatedOn')"
                             prop="CreatedOn"
                             width="200">
              <template slot-scope="scope">
                {{scope.row.CreatedOn}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.Actions')"
                             width="120">
              <template slot-scope="scope">
                <!--        <el-tooltip class="item"
                            effect="dark"
                            content="Preview"
                            placement="bottom">
                  <el-button circle
                             size="mini"
                             icon="el-icon-view"
                             @click="previewReport(scope.row.UId, scope.row.Name)"
                             type="success"></el-button>
                </el-tooltip> -->
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('report.Delete')"
                            placement="bottom"
                            v-has="'Create Report'">
                  <el-button circle
                             size="mini"
                             icon="el-icon-delete"
                             @click="deleteReport(scope.row.UId)"
                             type="danger"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>

    <div>
      <pdfPreview :showDialog="pdfPreview.show"
                  :pdfFileName="pdfPreview.name"
                  :url="pdfPreview.url"
                  :showSendMail="pdfPreview.showSendMail"
                  :id="pdfPreview.id"
                  @closeDialog="handlePdfPreview"
                  @openSendMailDialog="openSendMailDialog">
      </pdfPreview>
      <sendMailDialog :showDialog="sendMailDialog.show"
                      :fileName="sendMailDialog.name"
                      :id="sendMailDialog.id"
                      @closeDialog="handleSendMail">
      </sendMailDialog>
      <reportConditionDialog :showDialog="newReportDialog.show"
                             :type="newReportDialog.type"
                             @closeDialog="handleNewReportDialog">
      </reportConditionDialog>
    </div>
  </div>
</template>

<script>
import { getTaskReportList, deleteReport } from '@/api/config'
import { mapState } from 'vuex'
import axios from 'axios'
import pdfPreview from '@/components/pdf/pdfPreview.vue'
import sendMailDialog from '@/components/report/sendMailDialog.vue'
import reportConditionDialog from '@/components/report/reportConditionDialog.vue'
import SortControl from '@components/common/sortBtnList'

export default {
  data () {
    return {
      loading: false,
      user: [],
      filter: {
        showFilter: false
      },
      tab: 'All',
      checkList: [],
      list: [],
      total: 0,
      condition: {
        Name: null,
        ReportType: null,
        PlanId: null,
        CreatedStartTime: null,
        CreatedEndTime: null,
        CreatedBy: null,
        PageIndex: 1,
        PageSize: 20,
        GetRecycle: false,
        OrderBy: 'LastUpdatedOn desc'
      },
      pdfPreview: {
        show: false,
        name: '',
        url: '',
        id: '',
        showSendMail: false
      },
      sendMailDialog: {
        show: false,
        name: '',
        id: ''
      },
      selectedId: '',
      newReportDialog: {
        show: false,
        type: 1
      },
      sortField: 'LastUpdatedOn',
      sortOrder: 'descending',
      sortType: [
        {
          name: this.$t('report.Name'),
          value: 'Name'
        }, {
          name: this.$t('report.Plan'),
          value: 'PlanName'
        }, {
          name: this.$t('report.CreatedOn'),
          value: 'CreatedOn'
        }],
      sortValue: 'desc',
      sortBy: 'CreatedOn'
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'reportType', 'reportConditionOrderby'])
  },
  created () {
    if (this.jobsiteID) {
      this.$store.dispatch('getProjectMember')
    } else {
      this.$store.dispatch('getCorpUser')
    }
    this.$store.dispatch('getReportType')
    this.setReportConditionOrderBy()
    this.getTaskReportList()
  },
  mounted () {

  },
  watch: {
    jobsiteID () {
      // this.$refs['filter'].resetFields()
      this.condition.PageIndex = 1
      this.getTaskReportList()
    }
  },
  methods: {
    clearFilter () {
      this.$refs['filter'].resetFields()
      this.filter.showFilter = false
      this.refresh()
    },
    closeFilter () {
      this.filter.showFilter = false
    },
    openFilter () {
      if (this.jobsiteID) {
        this.user = this.$store.state.projectUser
      } else {
        this.user = this.$store.state.cropUser
      }
      this.filter.showFilter = true
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getTaskReportList()
    },
    refresh () {
      this.condition.Name = null
      this.condition.ReportType = null
      this.condition.CreatedStartTime = null
      this.condition.CreatedEndTime = null
      this.condition.CreatedBy = null
      this.condition.PlanId = null
      this.$refs.reportTable.clearSort()
      this.getTaskReportList()
    },
    sortList () {
      if (this.sortValue === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.sort()
    },
    sort () {
      this.condition.OrderBy = this.getReportConditionOrderBy()
      this.saveReportConditionOrderBy()
      this.getTaskReportList()
    },
    getTaskReportList () {
      // if (this.sortOrder === 'ascending') {
      //   this.condition.OrderBy = this.sortField + ' asc'
      // } else {
      //   this.condition.OrderBy = this.sortField + ' desc'
      // }
      this.condition.OrderBy = this.getReportConditionOrderBy()
      this.condition.JobsiteId = this.jobsiteID
      for (let i in this.condition) {
        if (!this.condition[i]) {
          this.condition[i] = null
        }
      }
      this.loading = true
      getTaskReportList(this.condition).then(res => {
        this.list = res.Data
        this.list.forEach(ele => {
          ele.CreatedOn = this.$config.LocalTime(new Date(ele.CreatedOn))
          ele.CreatedOn = this.$config.formatDate(new Date(ele.CreatedOn), 'MM/dd/yyyy')
          switch (ele.ReportType) {
            case 0:
              ele.typeText = 'MoistureReport'
              ele.icon = 'report_2'
              break
            case 1:
              ele.typeText = 'CompletionReport'
              ele.icon = 'report_1'
              break
            case 2:
              ele.typeText = 'RH Report'
              ele.icon = 'report_2'
              break
            case 3:
              ele.typeText = 'CaCl Report'
              ele.icon = 'report_2'
              break
            case 4:
              ele.typeText = 'RH & CaCl Report'
              ele.icon = 'report_2'
              break
            case 5:
              ele.typeText = 'General Report'
              ele.icon = 'report_task'
              break
            case 6:
              ele.typeText = 'Labor Report'
              ele.icon = 'report_labor'
              break
            default:
          }
        })
        this.total = res.TotalCount
        this.loading = false
      })
    },
    downloadReport (id, name) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios({
        method: 'get',
        url: this.$config.baseURL + '/api/TaskReports/' + id + '/download?',
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res], {
          type: `application/pdf` // word文档为msword,pdf文档为pdf
        })
        let objectUrl = URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = objectUrl
        link.setAttribute('download', name + '.pdf')
        document.body.appendChild(link)
        link.click()
        loading.close()
      })
    },
    previewReport (id, name) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios({
        method: 'get',
        url: this.$config.baseURL + '/api/TaskReports/' + id + '/download?',
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res], {
          type: `application/pdf`
        })
        let objectUrl = URL.createObjectURL(blob)
        this.pdfPreview.show = true
        this.pdfPreview.name = name + '.pdf'
        this.pdfPreview.url = objectUrl
        this.pdfPreview.id = id
        this.pdfPreview.showSendMail = true
      })
      loading.close()
    },
    handlePdfPreview (val) {
      this.pdfPreview.show = false
      this.pdfPreview.name = ''
      this.pdfPreview.url = ''
    },
    deleteReport (id) {
      let params = []
      params.push(id)
      this.$confirm(this.$t('report.AreYouSureYouWantToDeleteThisReport'), this.$t('report.TIPS'), {
        confirmButtonText: this.$t('report.Yes'),
        cancelButtonText: this.$t('report.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteReport(params).then(res => {
          this.$refs.pagination.handleDelete()
        })
      })
    },
    handleSelectionChange (val) {
      this.checkList = []
      val.forEach(res => {
        this.checkList.push(res.UId)
      })
    },
    batchDelete () {
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('report.PleaseCheckOneTaskAtLast')
        })
        return
      }
      this.$confirm(this.$t('report.AreYouSureYouWantToDeleteTheseReport'), this.$t('report.TIPS'), {
        confirmButtonText: this.$t('report.Yes'),
        cancelButtonText: this.$t('report.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteReport(this.checkList).then(res => {
          this.getTaskReportList()
        })
      })
    },
    selectRow (row) {
      this.selectedId = row.UId
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.selectedId === row.UId) {
        return 'success-row'
      }
    },
    openSendMailDialog (id, name) {
      this.sendMailDialog.show = true
      this.sendMailDialog.name = name
      this.sendMailDialog.id = id
    },
    handleSendMail (val) {
      this.sendMailDialog.show = false
      this.sendMailDialog.name = ''
      this.sendMailDialog.id = ''
    },
    composeNewReportCommand (type) {
      return {
        type: type
      }
    },
    handleNewReportCommand (commmand) {
      this.openNewReport(commmand.Type)
    },
    openNewReport (type) {
      this.newReportDialog.show = true
      this.newReportDialog.type = type === 1 ? 1 : type === 2 ? 4 : 5
    },
    handleNewReportDialog (needRefresh) {
      this.newReportDialog.show = false
      if (needRefresh === true) {
        this.getTaskReportList()
      }
    },
    sortChange (column) {
      this.sortField = column.prop
      this.sortOrder = column.order
      this.getTaskReportList()
    },
    changeReportType (tab, event) {
      this.condition.PageIndex = 1
      if (tab.name !== 'All') {
        this.reportType.forEach(res => {
          if (tab.name === res.Value) {
            this.condition.ReportType = res.Key
          }
        })
      } else {
        this.condition.ReportType = null
      }
      this.getTaskReportList()
    },
    getReportConditionOrderBySplit () {
      return ' '
    },
    getReportConditionOrderBy () {
      return this.sortBy + this.getReportConditionOrderBySplit() + this.sortValue
    },
    setReportConditionOrderBy () {
      let arr = this.reportConditionOrderby.split(this.getReportConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    saveReportConditionOrderBy () {
      this.$store.commit('setReportConditionOrderby', this.condition.OrderBy)
    }
  },
  components: {
    pdfPreview,
    sendMailDialog,
    reportConditionDialog,
    SortControl
  }
}
</script>

<style scoped lang="scss">
.svg-icon {
  font-size: 28px;
  color: #4193f6;
  margin-left: 6px;
}
.table-box {
  flex: 1;
  height: 0;
  position: relative;
  margin: 0 8px;
  border: 1px solid #dcdfe6;
  .table-icon {
    width: 24px;
  }
  .row-name {
    line-height: 24px;
  }
  .row-link {
    cursor: pointer;
    width: 100%;
    height: 100%;
    color: #409eff;
    text-decoration: none;
  }
}
/deep/.el-tabs__nav-wrap::after {
  background: none;
}
/deep/.el-table .success-row {
  background: #f0f9eb;
}
</style>
